/**
 * Registry de módulos configuráveis do ERP (hub /erp/configuracoes).
 */

import { Rocket, Image, LayoutTemplate, Truck, TicketPercent, ShieldCheck } from 'lucide-react';
import type { ErpIcon } from './erpNavigation';
import { MODULES, ACTIONS } from '../hooks/usePermissions';

export interface ErpSettingsModule {
  id: string;
  label: string;
  description: string;
  path: string;
  icon: ErpIcon;
  color: string;
  module: string;
  action: string;
}

export const ERP_SETTINGS_MODULES: ErpSettingsModule[] = [
  {
    id: 'cockpit',
    label: 'Cockpit',
    description: 'Metas mensais, milestones e prêmios de vendas',
    path: '/erp/configuracoes/cockpit',
    icon: Rocket,
    color: 'bg-emerald-600',
    module: MODULES.SETTINGS,
    action: ACTIONS.VIEW,
  },
  {
    id: 'hero',
    label: 'Hero / Banners',
    description: 'Carrossel da home (clássico ou duas fotos + produto)',
    path: '/erp/configuracoes/hero',
    icon: LayoutTemplate,
    color: 'bg-teal-600',
    module: MODULES.SETTINGS,
    action: ACTIONS.VIEW,
  },
  {
    id: 'storefront',
    label: 'Vitrine',
    description: 'Cores e sessões/trilhos da home',
    path: '/erp/configuracoes/vitrine',
    icon: Image,
    color: 'bg-sky-600',
    module: MODULES.SETTINGS,
    action: ACTIONS.VIEW,
  },
  {
    id: 'shipping-zones',
    label: 'Frete por CEP',
    description: 'Faixas e valores da tele-entrega local',
    path: '/erp/configuracoes/frete-cep',
    icon: Truck,
    color: 'bg-cyan-600',
    module: MODULES.SETTINGS,
    action: ACTIONS.VIEW,
  },
  {
    id: 'coupons',
    label: 'Cupons',
    description: 'Códigos promocionais do e-commerce',
    path: '/erp/configuracoes/cupons',
    icon: TicketPercent,
    color: 'bg-violet-600',
    module: MODULES.SETTINGS,
    action: ACTIONS.VIEW,
  },
  {
    id: 'certificates',
    label: 'Certificado digital',
    description: 'Certificado A1 usado para assinar prontuário e evoluções',
    path: '/erp/configuracoes/certificados',
    icon: ShieldCheck,
    color: 'bg-green-700',
    module: MODULES.DIGITAL_CERTIFICATE,
    action: ACTIONS.DIGITAL_CERTIFICATE_MANAGE,
  },
];
